<template>
  <mu-card class="pulse-ranges">
    <mu-card-text class="top-label">Your heart rate statistics for {{moment(data.date).format('Do MMM YY')}}</mu-card-text>
    <mu-card-text v-if="isLoading" class="top-label">{{$t('message.loadingText')}}</mu-card-text>
    <mu-card-text>
      <mu-row v-if="!isLoading">
        <mu-col width="33" tablet="33" desktop="33">
          <radial-progress
            data-id="radial-min"
            :value="data.min"
            color="#9781F0"
          ></radial-progress>
          <div class="center">
            MIN
          </div>
        </mu-col>
        <mu-col width="33" tablet="33" desktop="33">
          <radial-progress
            data-id="radial-max"
            :value="data.max"
            color="#F1696B"
          ></radial-progress>
          <div class="center">
            MAX
          </div>
        </mu-col>
        <mu-col width="33" tablet="33" desktop="33">
          <radial-progress
            data-id="radial-avg"
            :value="data.avg"
            color="#6EDEEA"
          ></radial-progress>
          <div class="center">
            AVG
          </div>
        </mu-col>
      </mu-row>
    </mu-card-text>
  </mu-card>
</template>

<script type="text/babel">
  import RadialProgress from "../../../RadialProgress/RadialProgress";
  import MuCircularProgress from "muse-ui/src/circularProgress/circularProgress";

  export default {
    components: {
      MuCircularProgress,
      RadialProgress
    },
    name: "pulse-range",
    data() {
      return {
        isLoading: false,
        data: {}
      }
    },
    methods: {
      moment(date) {
        return moment(date);
      }
    },
    mounted() {
      let self = this;
      self.$EventBus.$on('emitHeartRateStats', (data) => {
        self.isLoading = true;
        self.data = data;
        self.$nextTick(() => {
          self.isLoading = false;
        }, 1000);
      });
    },
  }
</script>
<style lang="less">
  .pulse-ranges {
    .center {
      text-align: center;
    }
    .top-label {
      color: black;
      padding-bottom: 0 !important;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// Pulse.vue?41b9e704